export default {
    methods: {
        imageToCartAnimation(element, target) {
            const newCanvas = document.createElement('canvas');
            const context = newCanvas.getContext('2d');
            const oldCanvas = document.querySelector(element);

            //set dimensions
            newCanvas.width = oldCanvas.clientWidth;
            newCanvas.height = oldCanvas.clientHeight;

            //apply the old canvas to the new one
            context.drawImage(oldCanvas, 0, 0);

            const box = oldCanvas.getBoundingClientRect();

            newCanvas.style.position = 'fixed';
            newCanvas.style.top = box.top + 'px';
            newCanvas.style.left = box.left + 'px';

            document.body.appendChild(newCanvas);

            setTimeout(() => {
                newCanvas.classList.add(target);

                setTimeout(() => {
                    newCanvas.remove();
                }, 900);
            }, 100);
        },
        shakeCartAnimation() {
            let cartButton = document.querySelector('.cart-button');
            if (!cartButton.classList.contains('shake')) {
                cartButton.classList.add('shake')
            }

            setTimeout(() => {
                cartButton.classList.remove('shake');
            }, 1000)
        },
    }
}